"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotParentBindingConstraintsWithServiceId = isNotParentBindingConstraintsWithServiceId;
const isBindingConstraintsWithServiceId_1 = require("./isBindingConstraintsWithServiceId");
const isNotParentBindingConstraints_1 = require("./isNotParentBindingConstraints");
function isNotParentBindingConstraintsWithServiceId(serviceId) {
    return (0, isNotParentBindingConstraints_1.isNotParentBindingConstraints)((0, isBindingConstraintsWithServiceId_1.isBindingConstraintsWithServiceId)(serviceId));
}
//# sourceMappingURL=isNotParentBindingConstraintsWithServiceId.js.map